import React from 'react';
import TopBarComponent from '../../components/topBar/TopBar.component';

export const IncapacityInfoScreen: React.FC = () => {
  return (
    <>
      <TopBarComponent
        title={'Incapacity'}
        subTitle={'View Incapacity Module Information'}
        hideSearch={true}
      ></TopBarComponent>
      <div className="content">
        <div className="text-muted px-4 pt-4" style={{ fontSize: '16px' }}>
          The schematics below provides a roadmap of the process you will follow in LabourTeq as you begin, execute and
          close Incapacity poor performance cases. Intuitive flows and resources will guide you through each step of a
          case.
          <br />
          The appeal schematic and process in LabourTeq is relevant only if your companys Incapacity Poor Performance
          Policy & Procedure allows for an appeal process.
          <br />
          <div>
            <img src={require('../../assets/img/Incapacity.png')} alt={'Incapacity Flow'} />
          </div>
          <div>
            <img src={require('../../assets/img/Appeal.png')} alt={'Appeal Flow'} />
          </div>
        </div>
      </div>
    </>
  );
};
